import { QueryResult, useQuery } from '@eika-infrastruktur/react-query';

import validateCrossBorderWarnings from '../components/transaction/CrossBorderPayment/Summary/validateCrossBorderWarnings';
import { CrossBorderPaymentState } from '../components/transaction/CrossBorderPayment/form/state';
import { ValidateCrossBorderResponse } from '../generated-types';
import { validatePayment } from '../services/crossBorderPaymentsService';
import createCrossBorderPaymentRequest from '../utils/mapper/createCrossBorderPaymentRequest';

const useValidateCrossBorderPayment = (
    state: CrossBorderPaymentState,
    invalidAccountNumberCallback: (invalidError: boolean) => void,
    errorCallback: (blockedError: boolean) => void,
    sepaWarningCallback: (warning: boolean) => void,
): QueryResult<ValidateCrossBorderResponse> =>
    useQuery({
        queryKey: ['validate'],
        queryFn: () => {
            const request = createCrossBorderPaymentRequest(state);
            return validatePayment(request, false);
        },
        onSuccess: (data) =>
            validateCrossBorderWarnings(data, invalidAccountNumberCallback, errorCallback, sepaWarningCallback),
    });

export default useValidateCrossBorderPayment;
